import {
  Info as TheIcon
} from 'components/icons';

// OR
// import React from 'react';
// import { Icon } from "semantic-ui-react";

// function TheIcon (props) {
//   return <Icon name="info" {...props} />;
// }

export const meta = {
  id: 'SocialNetworksPreviewer',
  title: 'SocialNetworksPreviewer',
  category: 'CMS',
  // exposes: [
  //   {
  //     title: 'General',
  //     action: { module: 'SocialNetworksPreviewer', props: { /* */ } },
  //     desription: 'general-desc',
  //   },
  // ],
  unique: true,
  icon: TheIcon,
  version: '1.0.0',
  description: `Will preview an approximation of how social networks will render some data`,
  windowOptions: {
    width: 420,
    height: 640,
    resizable: false,
    canMaximize: false
    // if not passed, will be centered
    // x: null,
    // y: null,
    // width: 630,
    // height: 380
  }
};
